import { render, staticRenderFns } from "./CardEcosystem.vue?vue&type=template&id=ec69c7c2&scoped=true"
import script from "./CardEcosystem.vue?vue&type=script&lang=js"
export * from "./CardEcosystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec69c7c2",
  null
  
)

export default component.exports